import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'

export default {
  name: 'bag-close-details',
  components: {VueElementLoading},
  props: ['hubid'],
  data () {
    return {
      isLoading: false,
      listmodal:false,
      isBagNumberError: 0,
      BagNumberError: '',
      bagNumber:'',
      modaldata:'',
      BagDetails:[],
      rowdata :''
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted () {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
  },
  methods: {
    openlistmodal(data,d){
      this.modaldata = data.ShippingIds
      this.rowdata = d
      this.listmodal = true
    },
    closelistmodal(){
      this.listmodal = false
    },
    getBagDetails() {
      this.BagDetails = []
      if (this.bagNumber == '') {
        this.isBagNumberError = '1',
        this.BagNumberError = 'The Bag Number field is required.'
        return false;
      } else {
        this.isBagNumberError = '',
        this.BagNumberError = ''
      }
      this.isLoading = true
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getGenerateBagDetailsByBagNumberForSorter?bagNumber='+this.bagNumber.trim()+'&currentHubId='+this.hubid,
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false
            this.BagDetails = result.data.ResponseData
          } else {
            this.isLoading = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    closeBag(closeBagData) {
      delete closeBagData.AuthKey;
      delete closeBagData.GroupId;
      delete closeBagData.RouteCode;
      
      let apiName;
      if(this.hubid == 270)
      {
       apiName = 'addShipmentToBagForCrossBeltSorter' 
      }
      else if(this.hubid == 3037)
      {
        apiName = 'addShipmentToBagForSorter'
      }
      else if(this.hubid == 3223)
      {
        apiName = 'addShipmentToBagForCrossBeltSorterSurat'
      }
      else{
        apiName = 'addShipmentToBagForFalconSorter'
      }

      this.isLoading = true
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + apiName,
          data: closeBagData,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
            if (result.data.ResultCode == 100) {
              this.isLoading = false
              this.$alertify.success(result.data.ReturnMessage)
              this.getBagDetails();
            } else {
              this.isLoading = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          },
          error => {
            this.isLoading = false
            console.error(error)
          })
    },
    clearError(){
      if (this.bagNumber == '') {
        this.isBagNumberError = '1',
        this.BagNumberError = 'The Bag Number field is required.'
      } else {
        this.isBagNumberError = '',
        this.BagNumberError = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/FalconSorter/BagCloseDetails/BagCloseDetails.js